import { requestApi } from './Api';

export const getPatientLedger = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/billing/patient_ledger/get',
    params
  });

export const getPatientLedgerCSV = (navigate, params) =>
  requestApi({ navigate, url: '/api/practice/billing/patient_ledger/get_csv', params });

export const generateLedgerPdf = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/billing/patient_ledger/pdf',
    params,
    responseType: 'blob'
  });

export const updateOtherAdj = (navigate, params) =>
  requestApi({
    navigate,
    params,
    url: '/api/practice/billing/patient_ledger/update_other_adj'
  });
